import styled from "styled-components";

export const MinhasIdeiasContainer = styled.div`
  margin: 0 20px;
  height: 400px;
  overflow: auto;
  padding: 0 16px;
  border: 1px solid rgba(140, 140, 140, 0.35);
`;